import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { QuillMaterialComponent } from "@tt-lib/components/quill-material/quill-material.component";

export type TraceCreateWayPointDialogData = {
  maxNameLength: number;
  maxDescriptionLength: number;
  isNew: boolean;
  name: string;
  desc: string;
  index: number
}
export type TraceCreateWayPointUpdateData = {
  remove: boolean,
  index: number,
  name: string,
  desc: string
}
@Component({
  selector: 'tt-trace-create-waypoint-dialog',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    QuillMaterialComponent
  ],
  templateUrl: './trace-create-waypoint-dialog.component.html',
  styleUrls: ['./trace-create-waypoint-dialog.component.scss'],
  standalone: true
})
export class TraceCreateWaypointDialogComponent implements OnInit {

  public editorForm!: FormGroup;
  public data = inject<TraceCreateWayPointDialogData>(MAT_DIALOG_DATA);
  constructor(
    private formBuilder: FormBuilder,
    private _dialogRef: MatDialogRef<TraceCreateWaypointDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.editorForm = this.formBuilder.group({
      name: new FormControl(this.data.name ? this.data.name : '', Validators.maxLength(this.data.maxNameLength)),
      desc: new FormControl(this.data.desc ? this.data.desc : '', { validators: [(control: AbstractControl) => { const l = this.getHtmlLength(control.value); if (l > this.data.maxDescriptionLength) { control.markAsDirty(); control.markAllAsTouched() }; return l <= this.data.maxDescriptionLength ? null : { maxlength: { requiredLength: this.data.maxDescriptionLength, actualLength: l } } }] })
    });
  }

  update(remove: boolean, wayPointIndex: number): TraceCreateWayPointUpdateData {
    return { remove: remove, index: wayPointIndex, name: remove ? null : (this.editorForm.controls['name'].value ? this.editorForm.controls['name'].value.trim() : ''), desc: remove ? null : (this.editorForm.controls['desc'].value ? this.editorForm.controls['desc'].value.trim() : '') }
  }

  get descLength() {
    return this.getHtmlLength(this.editorForm.controls['desc'].value);
  }

  /**
   * removing tags before calculating the length
   */
  getHtmlLength(htmlString: string): number {
    const htmlObject = document.createElement('div');
    htmlObject.innerHTML = '<div>' + (htmlString ? htmlString : '') + '</div>';
    return htmlObject.getElementsByTagName("div")[0].innerText.trim().length;
  }
}